import Vue from 'vue';
import Vuex from 'vuex';
import VueHtmlToPaper from 'vue-html-to-paper';
import VueExcelXlsx from 'vue-excel-xlsx';
import common from './modules/common';
import global from './modules/global';

Vue.use(Vuex);
Vue.use(VueExcelXlsx);

const debug = process.env.NODE_ENV !== 'production';

const options = {
  name: '_blank',
  specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
  styles: ['https://cdnjs.cloudflare.com/ajax/libs/semantic-ui/2.4.1/semantic.min.css'],
};

Vue.use(VueHtmlToPaper, options);

export default new Vuex.Store({
  modules: {
    common,
    global,
  },
  strict: debug,
});
